import type { PaginationOptions, PaginationProgress } from '../types';

// gloss
const MAX_PAGES = 1000;

// gloss
export const applyCaps = (options: PaginationOptions<never>, progress: PaginationProgress): boolean => {
  if (progress.rows >= (options.maxRows ?? Number.POSITIVE_INFINITY)) {
    options.onCapped?.({ reason: 'maxRows', returned: progress.rows });
    return true;
  }
  if (progress.pages >= (options.maxPages ?? MAX_PAGES)) {
    options.onCapped?.({ reason: 'maxPages', returned: progress.rows });
    return true;
  }
  return false;
};
